import { render, staticRenderFns } from "./TouchScreenTaskList.vue?vue&type=template&id=2ba4bb6c&scoped=true&"
import script from "./TouchScreenTaskList.vue?vue&type=script&lang=js&"
export * from "./TouchScreenTaskList.vue?vue&type=script&lang=js&"
import style0 from "./TouchScreenTaskList.vue?vue&type=style&index=0&id=2ba4bb6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba4bb6c",
  null
  
)

export default component.exports